module.exports = __webpack_public_path__ + "img/core2.9bd64479.png";